import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {WebSourcesVariant} from '../web-sources/web-sources.types';

/** Which tool the placeholder stands in for: a web search, or reading a link the user shared. */
export interface WebSourcesSkeletonProps {
  variant: WebSourcesVariant;
}

export type WebSourcesSkeletonComponentPart = BaseComponentPart<StreamComponentType.WEB_SOURCES_SKELETON, WebSourcesSkeletonProps>;

export type WebReadSkeletonComponentPart = BaseComponentPart<StreamComponentType.WEB_READ_SKELETON, WebSourcesSkeletonProps>;

export const SKELETON_FAVICON_COUNT = 3;
export const SKELETON_FAVICON_SIZE = 20;
